import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { LoginPrompt } from './homepage/login-prompt/LoginPrompt';
import { selectors as authSelectors } from '../store/slices/authSlice';
import { Paths, Locale } from '../types/gatsby';

interface ShowLoginPromptProps {
  localizedPaths: Paths | undefined;
}

const promptNotAllowedList = ['login', 'lost-password', 'accountgegevens-opvragen', 'recuper-info-de-compte', 'lostpassword-localized', undefined];

export const ShowLoginPrompt = ({ localizedPaths }: ShowLoginPromptProps) => {
  const intl = useIntl();
  const { locale } = intl;
  const isLoggedIn = useSelector(authSelectors.isLoggedIn);

  let showPrompt = false;
  const actualPath: string = localizedPaths ? localizedPaths[locale as Locale] : '';

  if (!isLoggedIn) {
    const pathParamArray = actualPath.split('/');

    if (!promptNotAllowedList.includes(pathParamArray[2])) {
      showPrompt = true;
    }
  }

  if (!showPrompt) return null;

  return <LoginPrompt pagePath={actualPath} />;
};
